import { Entity, MicroMClient } from "@mcurros2/microm";
import { DashboardV2Def } from "./DashboardV2Def";
import { IconDashboard } from "@tabler/icons-react";

export class DashboardV2 extends Entity<DashboardV2Def> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new DashboardV2Def(), parentKeys);
        this.Form = import('./DashboardV2Form').then((module) => module.DashboardV2Form);
        this.Title = "DashboardV2";
        this.HelpText = '* DashboardV2.';
        this.Icon = IconDashboard;
    }
}